// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"b95c7c18","227":"f5edf268","254":"ef843f92","370":"cfb6df87","395":"4f4dd895","518":"f73d5000","787":"cda612ba","929":"c2c3d16c"}[chunkId] + ".chunk.js";
};